import { createContext, useContext, useMemo, useState } from "react";

interface ModalContextData {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

const ModalContext = createContext<ModalContextData>({
    isOpen: false,
    openModal: () => {},
    closeModal: () => {},
});

export function useModal() {
    return useContext(ModalContext);
}

export function ModalProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const ModalContextValue = useMemo(() => {
        return { isOpen, openModal, closeModal };
    }, [isOpen]);

    return (
        <ModalContext.Provider value={ModalContextValue}>
            {children}
        </ModalContext.Provider>
    );
}
